import MoreAbouteMe from "../components/sections/About/MoreAboutMe"

const MoreAbout = () => {
    return <MoreAbouteMe />
}

export default MoreAbout;